import styled from 'styled-components'
import { groupNameColor } from '../../../constants/contentfulStyle.constant'

const customXLBreakpoint = 1680
const customSMBreakpoint = 850

export const Navbar = styled.nav.attrs((props: any) => ({
  openMenu: props.openMenu,
}))`
  margin: auto;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 500;
  background-color: ${({ theme }) => theme?.webMktPalette?.background.white};

  ${({ openMenu }) => {
    return openMenu
      ? `
      height: calc(100vh - 66px);
      overflow-y: scroll;
    `
      : ``
  }}
`

export const NavbarContainer = styled.div.attrs((props: any) => ({
  openMenu: props.openMenu,
}))`
  margin: auto;
  max-width: ${customXLBreakpoint}px;
  display: grid;
  grid-template-columns: 136px repeat(2, 1fr) auto;
  align-items: center;
  justify-items: end;
  padding: 0 40px;

  .Navbar__Logo {
    justify-self: start;

    & > img {
      width: 136px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    grid-template-columns: 110px repeat(2, 1fr) auto;
    padding: 0 32px;

    .Navbar__Logo > img {
      width: 110px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 0;

    .Navbar__Mobile_Top {
      padding: 24px 0;

      img {
        margin-left: 24px;
      }
    }

    .Navbar__Main_Button {
      margin-right: 24px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    padding: 0;
    grid-template-columns: 100%;
    grid-template-rows: ${({ openMenu }: any) =>
      openMenu ? '70px 73px auto auto' : '70px auto auto auto'};
    position: relative;
    height: 100%;
    align-items: start;

    .Navbar__Mobile_Top {
      position: sticky;
      top: 0;
      z-index: 1000;
      width: 100%;
      background-color: ${({ theme }) => theme?.webMktPalette?.background.white};
      padding: 16px 0;

      img {
        margin-left: 16px;
      }
    }

    .Navbar__Main_Button {
      width: 100%;
      grid-row: 4 / 5;
      display: ${({ openMenu }: any) => (openMenu ? 'block' : 'none')};
      text-align: center;
      margin: 0 auto;
      padding: 24px 0;

      align-self: end;
      position: sticky;
      bottom: 0;
      background-color: ${({ theme }) => theme?.webMktPalette?.background.white};

      a {
        width: calc(100% - 64px);
        justify-content: center;
      }
    }
  }
`

export const NavLinksWrapper = styled.ul.attrs((props: any) => ({
  openMenu: props.openMenu,
  isHovered: props.isHovered,
}))`
  justify-self: start;
  margin-left: 32px;
  display: flex;

  .Navbar__Mobile_Button {
    display: none;
  }

  .Menu-item::before {
    right: 38px;
  }

  .Menu-item.is-active {
    background-color: unset;

    .Navbar__MegaMenu {
      display: flex;
      position: absolute;
      width: 100%;
    }

    h6 {
      color: ${({ theme }) => theme?.webMktPalette?.text.actionLight};
    }
  }

  .Menu-item.is-active:before {
    border-color: ${({ theme }) => theme?.webMktPalette?.background.black};
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-left: 20px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-row: 2 / 2;
    grid-column: 1 / 5;
    justify-self: stretch;
    justify-content: space-around;
    margin: 0;
    border-top: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};

    .NavLink__Active {
      .Navbar__MenuGroup > .Navbar__MegaMenu {
        display: block;
        max-height: 70vh;
        overflow-y: auto;
      }
    }

    .Navbar__Mobile_Button {
      display: block;
      padding: 16px 32px;
      width: 100%;
      text-align: left;
      text-transform: none;
    }

    .Menu-item::before {
      display: none;
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    grid-row: 3 / 4;
    flex-direction: column;
    display: ${({ openMenu }) => (openMenu ? 'block' : 'none')};
    margin: 0;

    .NavLink__Active {
      .Navbar__MenuGroup > .Navbar__MegaMenu {
        max-height: 100%;
      }
    }

    .Menu-item::before {
      display: block;
    }
  }
`

export const NavLink = styled.li.attrs((props: any) => ({
  currActiveNavLink: props.currActiveNavLink,
  prevActiveNavLink: props.prevActiveNavLink,
}))`
  .Navbar__MenuGroup {
    margin: auto 0;

    & > a {
      display: block;
      padding: 32px 12px;
      position: relative;
    }

    &:hover {
      & > a::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 89px;
        z-index: 600;
        transform: translateX(-50%);
        border-width: 8px 9px;
        border-style: solid;
        border-color: transparent;
        border-top-color: ${({ theme }) => theme?.webMktPalette?.text.actionLight};
      }

      .Navbar__MegaMenu {
        display: flex;
      }

      h6 {
        color: ${({ theme }) => theme?.webMktPalette?.text.actionLight};
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    .Navbar__MenuGroup {
      h6 {
        ${({ theme }) => theme.webMktTypography.typography.heading6.md};
      }

      &:hover {
        & > a::after {
          top: 85px;
        }
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    .Navbar__MenuGroup {
      & > a {
        padding: 20px 12px;
        display: none;
      }

      &:hover {
        & > a::after {
          top: 60px;
        }
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    border-bottom: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};
  }
`

export const MegaMenu = styled.div.attrs((props: any) => ({
  direction: props.direction,
  numOfGrayColumns: props.numOfGrayColumns,
  maxLength: props.maxLength,
  doesMainNavBannerExist: props.doesMainNavBannerExist,
}))`
  position: absolute;
  left: 0;
  background-color: ${({ theme }) => theme?.webMktPalette?.background.white};
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};
  box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.2);
  display: none;

  .MegaMenu__Side {
    width: 100%;
  }

  ${({ theme, direction, numOfGrayColumns, maxLength, doesMainNavBannerExist }: any) => {
    let backgroundStyle = ``

    if (numOfGrayColumns >= maxLength) {
      return `
        .MegaMenu__Side:last-child {
          background-color: ${theme.webMktPalette.background.gray};
        }

        .MegaMenu__Side:first-child {
          background-color: ${theme.webMktPalette.background.gray};
        }
      `
    } else {
      if (direction === 'Right') {
        backgroundStyle += `
          .MegaMenu__Side:last-child {
            background-color: ${theme.webMktPalette.background.gray};
          }
        `
      }

      if (direction === 'Left') {
        backgroundStyle += `
          .MegaMenu__Side:first-child {
            background-color: ${theme.webMktPalette.background.gray};
          }
        `
      }
    }

    if (doesMainNavBannerExist) {
      backgroundStyle += `
        .MegaMenu__Side:last-child {
          background-color: ${theme.webMktPalette.background.gray};
        }
      `
    }

    return backgroundStyle
  }}

  @media (max-width: ${customXLBreakpoint}px) {
    .MegaMenu__Side {
      display: none;
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    position: static;
    box-shadow: unset;
  }
`

export const MegaMenuContainer = styled.ul`
  max-width: ${customXLBreakpoint}px;
  min-width: ${customXLBreakpoint}px;
  margin: auto;
  display: flex;
  align-items: start;
  width: 100%;

  @media (max-width: ${customXLBreakpoint}px) {
    min-width: auto;

    .MegaMenu__Side {
      display: none;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    align-items: stretch;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
    width: 100%;
  }
`

export const MegaMenuSection = styled.li.attrs((props: any) => ({
  textColor: props.textColor,
  numOfGrayColumns: props.numOfGrayColumns,
  direction: props.direction,
  position: props.position,
  maxLength: props.maxLength,
  doesContentExist: props.doesContentExist,
  hasIconLink: props.hasIconLink,
  doesMainNavBannerExist: props.doesMainNavBannerExist,
}))`
  flex: 1;
  position: relative;
  width: 100%;
  ${({ theme, doesMainNavBannerExist, position, maxLength }) => {
    return doesMainNavBannerExist && position === maxLength
      ? `
      display: flex;
      align-self: stretch;
      background-color: ${theme.webMktPalette.background.gray};
    `
      : ``
  }}

  .Navbar__Section_Container {
    padding: 32px 10%;
    margin-left: 24px;

    .Navbar__Section_Name {
      letter-spacing: 1px;
      margin-bottom: 12px;
      font-weight: 500;
      color: ${({ textColor }: any) => groupNameColor(textColor)};
      text-transform: uppercase;
    }

    .Navbar__Section_Description {
      letter-spacing: 0.3px;
      margin-bottom: 16px;
      line-height: 18px;
      color: ${({ theme }) => theme.webMktPalette.text.secondary};
    }
  }

  &::after {
    content: ' ';
    position: absolute;
    border-left: 1px solid #ecedee;
    top: 50%;
    transform: translateY(-50%);
    height: calc(100% - 64px);
  }

  &:first-child::after {
    border-left: none;
  }

  ${({ theme, numOfGrayColumns, direction, position, maxLength }: any) => {
    let sectionStyle = ``

    if (direction === 'Left') {
      if (position <= numOfGrayColumns) {
        sectionStyle += `
          background-color: ${theme.webMktPalette.background.gray};
          align-self: stretch;
        `
      } else if (position - 1 === numOfGrayColumns) {
        sectionStyle += `
          &::after {
            border-left: none;
          }
        `
      }
    } else if (direction === 'Right') {
      if (position - 1 + numOfGrayColumns === maxLength) {
        sectionStyle += `
          &::after {
            border-left: none;
          }
        `
      }

      if (position - 1 + numOfGrayColumns >= maxLength) {
        sectionStyle += `
          background-color: ${theme.webMktPalette.background.gray};
          align-self: stretch;
        `
      }
    } else {
      return ``
    }

    return sectionStyle
  }}

  ${({ theme }) => theme.breakpoints.down('lg')} {
    .Navbar__Section_Container {
      padding: 32px 12px;
      margin: auto 20px;
    }

    &:first-child {
      padding-left: 12px;
    }

    &:last-child {
      padding-right: 12px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    .Navbar__Section_Container {
      padding: 32px 6px;
      margin: auto 6px;

      .Navbar__Section_Name {
        font-size: ${({ theme }) => theme.typography.fontSize}px;
      }
    }

    &::after {
      border-left: none;
    }

    &:first-child {
      padding-left: 22px;
    }

    &:nth-child(2) {
      padding-left: 12px;
    }

    &:last-child {
      padding-right: 10px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    border-bottom: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};

    &:first-child,
    &:nth-child(2) {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }

    .Navbar__Section_Container {
      margin: auto 24px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: auto auto;
      grid-column-gap: 24px;

      .Navbar__Section_Content {
        grid-row: 1 / 2;
        grid-column: 1 / 2;
      }

      .SubList__Left,
      .SubList__Right {
        grid-row: 1 / 3;
      }

      .SubList__Left {
        margin-left: ${({ doesContentExist }) => (doesContentExist ? '15%' : 0)};
      }

      .SubList__Right {
        margin-left: ${({ doesContentExist }) => (doesContentExist ? 0 : '15%')};
      }
    }
  }

  @media (max-width: ${customSMBreakpoint}px) {
    .Navbar__Section_Container {
      .SubList__Left {
        margin-left: ${({ doesContentExist }) => (doesContentExist ? '5%' : 0)};
      }

      .SubList__Right {
        margin-left: ${({ doesContentExist }) => (doesContentExist ? 0 : '5%')};
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    border-bottom: none;
    background-color: ${({ theme }) => theme.webMktPalette.background.gray};

    .Navbar__Section_Container {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: auto auto;
      grid-column-gap: 20px;
      padding: 10px 0;

      .Navbar__Section_Content {
        grid-row: 1 / 2;
        grid-column: 1 / 3;
      }

      .Navbar__Section_Name {
        display: flex;
        align-items: center;

        &:after {
          content: ' ';
          height: 1px;
          margin-left: 24px;
          background: #000;
          flex: 2;
          background-color: ${({ theme }) => theme.webMktPalette.background.black};
          opacity: 0.1;
        }
      }

      .SubList__Left,
      .SubList__Right {
        margin-left: 0;
      }

      ${({ hasIconLink }) => {
        return hasIconLink
          ? `
          .SubList__Left {
            grid-column: 1 / 3;
            grid-row: 2 / 3;
          }
    
          .SubList__Right {
            grid-column: 1 / 3;
            grid-row: 3 / 4;
          }
        `
          : `
          .SubList__Left {
            grid-row: 2 / 3;
          }
    
          .SubList__Right {
            grid-row: 2 / 3;
          }
        `
      }}
    }
  }
`

export const SubListItem = styled.div.attrs((props: any) => ({
  subListLength: props.subListLength,
  isThereDescription: props.isThereDescription,
}))`
  a {
    p {
      padding: 6px 0;
    }

    &:hover {
      p {
        color: ${({ theme }) => theme?.webMktPalette?.text.actionLight};
      }

      .Navbar__IconLink_Caption {
        color: ${({ theme }) => theme.webMktPalette.text.secondary};
      }
    }
  }

  .Navbar__IconLink_Header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: ${({ isThereDescription }) => (isThereDescription ? '0' : '6px')};

    & > p {
      padding: 0;
    }
  }

  .Navbar__IconLink_Caption {
    color: ${({ theme }) => theme.webMktPalette.text.secondary};
  }

  .Navbar__IconLink_Caption {
    margin-top: 0;
    padding-top: 3px;
    margin-bottom: 5px;
    letter-spacing: 0.3px;
  }

  .Navbar__HighlightedLink {
    color: black;
    margin-top: 9px;

    .CTA__Arrow-Container {
      margin-left: 8px;

      &::before {
        font-size: 18px;
      }
    }

    span {
      font-size: ${({ theme }) => theme.typography.fontSize}px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    .Navbar__SubList_IconLink > div > p,
    .Navbar__SubList_Cta > p {
      font-size: ${({ theme }) => theme.typography.fontSize}px;
    }

    .Navbar__IconLink_Caption {
      width: 90%;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    .Navbar__HighlightedLink {
      margin: ${({ subListLength }) => (subListLength === 1 ? '5px 0' : '0')};
      padding: ${({ subListLength }) => (subListLength === 1 ? '6px 0' : '3px 0')};
    }
  }
`

export const IconLinksSection = styled.div.attrs((props: any) => ({
  openMenu: props.openMenu,
}))`
  display: flex;
  text-decoration: none;
  margin-right: 36px;

  .Navbar__TopHatLinks_Wrapper {
    display: flex;
    align-items: center;
    gap: 24px;
    padding-left: 24px;
    border-left: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};

    li:hover {
      p,
      img {
        color: ${({ theme }) => theme?.webMktPalette?.text.actionLight};
      }
    }

    a {
      display: flex;
      align-items: center;
      gap: 13px;

      p {
        font-weight: 700;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    gap: 35px;

    p {
      display: none;
    }

    .Navbar__TopHatLinks_Wrapper {
      gap: 33px;
      padding-left: 0;
      border-left: none;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-column: 3 / 4;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    grid-row: 2 / 3;
    grid-column: 1 / 2;
    display: ${({ openMenu }: any) => (openMenu ? 'block' : 'none')};
    text-align: center;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};
    background-color: ${({ theme }) => theme.webMktPalette.background.gray};
    padding: 18px 0;
    margin-right: 0;

    li {
      display: inline-block;
      flex: 1;
    }

    .Navbar__TopHatLinks_Wrapper {
      gap: 0;

      li a {
        display: flex;
        justify-content: center;
        border-left: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};
        padding: 6px 0;
      }

      li:first-child a {
        border-left: none;
      }

      p {
        display: block;
      }
    }
  }
`

export const HeaderSearch = styled.div`
  height: 22px;
  width: 22px;
  margin-right: 24px;

  .MainHeader-gcsSearchButton.searchIcon {
    svg {
      width: 22px;
      height: 22px;
      margin: auto;
      transform: scale(1) translateZ(0);
      transform-origin: 33% 33%;
      transition: transform 0.2s ease;

      &:hover {
        fill: ${p => p.theme.webMktPalette.icon.blueLight};
        transform: scale(1.2);
        transition: all 0.2s ease-out;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-right: 0;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    display: none;
  }
`

export const ResponsiveIcon = styled.div.attrs((props: any) => ({
  openMenu: props.openMenu,
}))`
  display: none;
  position: absolute;
  top: 21px;
  right: 16px;
  cursor: pointer;

  .Navbar__Hamburger {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: space-evenly;
    flex-flow: column nowrap;

    div {
      width: 20px;
      height: 2px;
      background-color: ${({ theme }) => theme?.webMktPalette?.background?.black};
    }
  }

  ${({ openMenu, theme }) => {
    return openMenu
      ? `
      width: 80px;

      &:hover {
        p {
          color: ${theme?.webMktPalette?.text.actionLight};
        }
      }
      
      .Navbar__Hamburger {
        position: relative;
        left: 55px;

        div {
          width: 24px;
        }

        div:nth-child(1) {
          transform: translate(-1px, 7px) rotate(-315deg);
          top: 20px;
        }
    
        div:nth-child(2) {
          opacity: 0;
        }
    
        div:nth-child(3) {
          transform: translate(-1px, -6px) rotate(-225deg);
        }
      }
    `
      : `
    `
  }}

  ${({ theme }) => theme.breakpoints.down('xs')} {
    display: block;
  }
`
export const BannerForward = styled.div`
  width: 100%;
  background: #fa4616;
  height: 56px;
  ${p => p.theme.breakpoints.down('xs')} {
    height: auto;
  }
  .Banner__forward--conainer {
    background: url(https://images.ctfassets.net/5965pury2lcm/6R4FjWfAyrz1i2K8oqqNub/a323c3fcea4155b5062c54f7dc039ddf/bg_fVI_banner.png)
      repeat-x #ccc;
    width: 795px;
    margin: 0 auto;
    display: flex;
    height: 100%;
    align-items: center;
    padding: 0 40px;
    box-sizing: border-box;
    justify-content: center;
    cursor: pointer;
    ${p => p.theme.breakpoints.down('sm')} {
      width: 100%;
      padding: 0;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      flex-direction: column;
      padding: 24px;
      align-items: flex-start;
    }
    h5 {
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      color: ${p => p.theme.webMktPalette.text.primaryBlack};
      padding: 0 16px;
      letter-spacing: normal;
      ${p => p.theme.breakpoints.down('xs')} {
        padding: 0;
        padding-top: 16px;
        padding-bottom: 4px;
      }
    }
    a.Register--Link {
      color: #fa4616;
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      background: transparent;
      padding: 0;
      .CTA__Arrow-Container {
        margin-left: 4px;
        svg #ArrowPath {
          fill: #fa4616;
        }
      }
      :hover {
        color: ${p => p.theme.webMktPalette.text.primaryBlack};
        text-decoration: none;
        svg #ArrowPath {
          fill: ${p => p.theme.webMktPalette.text.primaryBlack};
        }
        span {
          border-bottom: none;
        }
      }
    }
  }
`
